import { deleteRequest, get, post } from './_defaults/fetch.js';

export const getDocuments = async ({params, config}) => get('/documents', {params, ...config});
export const getDocument = async ({id, params, config}) => get(`/documents/${id}`, {params, ...config});
export const createDocument = async ({data, config}) => {
    const formData = new FormData();
    for (const key in data) {
        formData.append(key, data[key]);
    }
    return await post('/documents', formData, config);
};
export const createDocuments = async ({data, config}) => {
    let responses = [];
    const { files, ...rest } = data;
    for (const file of files) {
        const response = await createDocument({
            data: {
                ...rest,
                file
            },
            config
        });
        responses.push(response);
    }
    return responses;
};
export const updateDocument = async ({id, data, config}) => post(`/documents/${id}`, data, config);
export const reloadDocument = async ({id, config}) => post(`/documents/${id}/reload`, null, config);
export const deleteDocument = async ({id, config}) => deleteRequest(`/documents/${id}`, null, config);

export const createDocumentFolder = ({id, data, config}) => post(`/documents/${id}/folders`, data, config);
export const deleteDocumentFolder = ({id, folderId, config}) => deleteRequest(`/documents/${id}/folders/${folderId}`, null, config);

export const createDocumentArea = ({id, data, config}) => post(`/documents/${id}/areas`, data, config);
export const deleteDocumentArea = ({id, areaId, config}) => deleteRequest(`/documents/${id}/areas/${areaId}`, null, config);

export const createDocumentOffice = ({id, data, config}) => post(`/documents/${id}/offices`, data, config);
export const deleteDocumentOffice = ({id, officeId, config}) => deleteRequest(`/documents/${id}/offices/${officeId}`, null, config);

export const createDocumentTag = ({id, data, config}) => post(`/documents/${id}/tags`, data, config);
export const deleteDocumentTag = ({id, tagId, config}) => deleteRequest(`/documents/${id}/tags/${tagId}`, null, config);